export default {
  header: 'Smak',
};
